import { Directive } from '@angular/core';

@Directive({
  selector: '[uniDescription]',
})
export class UniDescriptionDirective {}
